import {
  pushButtonClickedEvent,
  pushLinkClickedEvent,
  pushCardClickedEvent,
  pushFilterAppliedEvent,
  pushScreenOpenedEvent
} from '@/util/gtm'

export default {
  // The install method will be called with the Vue constructor as
  // the first argument, along with possible options
  install (Vue) {
    Vue.prototype.$gtm = {
      buttonClicked: pushButtonClickedEvent,
      linkClicked: pushLinkClickedEvent,
      cardClicked: pushCardClickedEvent,
      filterApplied: pushFilterAppliedEvent,
      pageVisited: pushScreenOpenedEvent
    }
  }
}
